import { useQuery } from '@tanstack/react-query';

import { getCardRules } from '@/react-query/services/card-rules';

import { CardRule, CardType } from '@generated-types';
import { useCardId } from '@hooks/card/use-card-id';
import { useCardType } from '@hooks/card/use-card-type';

export const useCardRules = (explicitCardType?: CardType, explicitCardId?: string) => {
    const implicitCardId = useCardId();
    const implicitCardType = useCardType();

    const cardId = explicitCardId ?? implicitCardId;
    const cardType = explicitCardType ?? implicitCardType;

    return useQuery<CardRule>({
        queryKey: ['cardRule', cardType, cardId],
        queryFn: () => getCardRules(cardType!, cardId!),
        enabled: cardId !== undefined && cardType !== undefined,
    });
};

export default useCardRules;
